import { gql } from "graphql-request";

export const CREATE_SCENARIO_MODELING = gql`
  mutation CreateScenarioModeling($input: ScenarioModelingInput!) {
    createScenarioModeling(input: $input) {
      _id
      clientId
      name
      description
      monetary_impact
      recommendations {
        title
        effort
        time_to_implement_min
        time_to_implement_max
        impact
        kpi
        dependencies
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_SCENARIO_RESULT = gql`
  query GetScenarioResult($scenario_id: ID!) {
    getScenarioResult(scenario_id: $scenario_id) {
      _id
      clientId
      name
      description
      monetary_impact
      recommendations {
        title
        effort
        time_to_implement_min
        time_to_implement_max
        impact
        kpi
        dependencies
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_SCENARIO_RESULTS = gql`
  query GetAllScenarioResults($clientId: ID) {
    getAllScenarioResults(clientId: $clientId) {
      _id
      clientId
      name
      description
      monetary_impact
      recommendations {
        title
        effort
        time_to_implement_min
        time_to_implement_max
        impact
        kpi
        dependencies
      }
      createdAt
      updatedAt
    }
  }
`;

export const REFRESH_SCENARIO_RESULT = gql`
  mutation RefreshScenarioResult($scenario_id: ID!) {
    refreshScenarioResult(scenario_id: $scenario_id) {
      _id
      clientId
      name
      description
      monetary_impact
      recommendations {
        title
        effort
        time_to_implement_min
        time_to_implement_max
        impact
        kpi
        dependencies
      }
      createdAt
      updatedAt
    }
  }
`;

export const REFRESH_ALL_SCENARIO_RESULTS = gql`
  mutation RefreshAllScenarioResults($clientId: ID) {
    refreshAllScenarioResults(clientId: $clientId) {
      _id
      clientId
      name
      description
      monetary_impact
      recommendations {
        title
        effort
        time_to_implement_min
        time_to_implement_max
        impact
        kpi
        dependencies
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_SCENARIO_CARDS = gql`
  query GetScenarioCards($clientId: String!, $tenantId: String, $pageNo: Int, $pageSize: Int) {
    scenarioCards(clientId: $clientId, tenantId: $tenantId, pageNo: $pageNo, pageSize: $pageSize) {
      data {
        _id
        name
        country_list
        rate
        hts_codes
        clientId
        tenantId
        dateRange {
          start
          end
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_SCENARIO = gql`
  query GetScenario($id: ID!) {
    getScenario(_id: $id) {
      data {
        _id
        name
        country_list
        rate
        hts_codes
        clientId
        tenantId
        dateRange {
          start
          end
        }
      }
    }
  }
`;

export const CALCULATE_SCENARIO_METRICS = gql`
  query CalculateMetrics($scenarioId: ID!) {
    calculateScenarioMetrics(scenarioId: $scenarioId) {
      dutyAmount
      firstSale
      exclusion
      ftz
      engineering
      reclassification
      valueUnbundling
    }
  }
`;

export const CREATE_SCENARIO_CARD = gql`
  mutation CreateScenarioCard($scenarioCard: ScenarioCardInput!) {
    createScenarioCard(scenarioCard: $scenarioCard) {
      data
    }
  }
`;

export const UPDATE_SCENARIO = gql`
  mutation UpdateScenario($id: ID!, $input: UpdateScenarioCardInput!) {
    updateScenario(_id: $id, input: $input)
  }
`;

export const DELETE_SCENARIO = gql`
  mutation DeleteScenario($id: ID!) {
    deleteScenario(_id: $id)
  }
`;

export const GET_COUNTRY_SUMMARY = gql`
  query GetCountrySummary($clientId: ID!, $dateFrom: String, $dateTo: String) {
    getCountryOriginSummary(clientId: $clientId, dateFrom: $dateFrom, dateTo: $dateTo) {
      country_code
      total_duties
      total_goods_value
    }
  }
`;

export const GET_HTS_CODES = gql`
  query GetHTSCodes($clientId: ID!, $country_codes: [String!], $dateFrom: String, $dateTo: String) {
    getHTSCodesByCountry(clientId: $clientId, country_codes: $country_codes, dateFrom: $dateFrom, dateTo: $dateTo) {
      hts_code
      duty_value
      goods_value
    }
  }
`;
